import { isProductionEnv } from 'utils/environment'

import production from './production'
import staging from './staging'

export default isProductionEnv ? production : staging
